<script setup lang="ts">
const t2 = useT2({
  'Bank Name': 'Banko pavadinimas',
  'Account Holder Full Name': 'Sąskaitos savininko vardas ir pavardė',
  'Account Number (IBAN)': 'Sąskaitos numeris (IBAN)',
})

defineProps<{ item: gen.InputSellerPayoutBank | None }>()
</script>

<template>
  <UiLine :label="t2('Bank Name')" :value="item?.bankTitle" />
  <UiLine :label="t2('Account Holder Full Name')" :value="item?.bankAcconutHolderName" />
  <UiLine :label="t2('Account Number (IBAN)')" :value="item?.bankAccountNumber" />
  <UiLine :label="ts('BIC/SWIFT')" :value="item?.bankSwift" />
</template>
